import { appColors, Tier, TIERS } from '@backrs_ui/common-ui';

type TierBoxWithPopoverProps = Readonly<{
  isHighlighted: boolean;
  onClick: (event: React.MouseEvent<SVGElement, MouseEvent>) => void;
  setHoveredBox: (tier: Tier | null) => void;
  isHovered: boolean;
}>;

export const MiddleTierBox = ({
  isHighlighted,
  onClick,
  setHoveredBox,
  isHovered,
}: TierBoxWithPopoverProps) => {
  return (
    <>
      <rect
        x="390"
        y="226"
        width="160"
        height="89"
        rx="6"
        fill={isHighlighted ? '#5090FF' : '#D5E4FF'}
        onClick={onClick}
        cursor="pointer"
        onMouseEnter={() => setHoveredBox(TIERS.MID)}
        onMouseLeave={() => setHoveredBox(null)}
      />
      <path
        d="M424.922 256.8V268H422.378V262.08L420.282 268H418.458L416.362 262.08V268H413.818V256.8H416.474L419.37 265.232L422.266 256.8H424.922ZM429.086 256.8H431.662V268H429.086V256.8ZM435.822 256.8H439.966C443.07 256.8 444.622 258.597 444.622 262.192C444.622 263.589 444.446 264.709 444.094 265.552C443.753 266.395 443.209 267.013 442.462 267.408C441.726 267.803 440.75 268 439.534 268H435.822V256.8ZM439.774 265.952C440.339 265.952 440.787 265.829 441.118 265.584C441.449 265.339 441.689 264.944 441.838 264.4C441.987 263.856 442.062 263.12 442.062 262.192C442.062 260.987 441.897 260.128 441.566 259.616C441.246 259.104 440.697 258.848 439.918 258.848H438.398V265.952H439.774ZM447.957 256.8H452.101C455.205 256.8 456.757 258.597 456.757 262.192C456.757 263.589 456.581 264.709 456.229 265.552C455.888 266.395 455.344 267.013 454.597 267.408C453.861 267.803 452.885 268 451.669 268H447.957V256.8ZM451.909 265.952C452.474 265.952 452.922 265.829 453.253 265.584C453.584 265.339 453.824 264.944 453.973 264.4C454.122 263.856 454.197 263.12 454.197 262.192C454.197 260.987 454.032 260.128 453.701 259.616C453.381 259.104 452.832 258.848 452.053 258.848H450.533V265.952H451.909ZM460.092 256.8H462.668V265.952H467.9V268H460.092V256.8ZM470.977 256.8H478.641V258.848H473.553V261.104H478.097V263.152H473.553V265.952H478.641V268H470.977V256.8ZM481.267 262.976H486.067V264.512H481.267V262.976ZM491.665 258.672H488.369V256.8H497.537V258.672H494.241V268H491.665V258.672ZM500.89 256.8H503.466V268H500.89V256.8ZM507.626 256.8H515.29V258.848H510.202V261.104H514.746V263.152H510.202V265.952H515.29V268H507.626V256.8ZM518.621 256.8H522.733C525.304 256.8 526.589 257.856 526.589 259.968C526.589 260.693 526.44 261.317 526.141 261.84C525.853 262.363 525.432 262.752 524.877 263.008V263.04C525.069 263.179 525.218 263.312 525.325 263.44C525.432 263.568 525.517 263.707 525.581 263.856L527.213 268H524.493L523.245 264.656C523.128 264.357 522.973 264.16 522.781 264.064C522.6 263.968 522.269 263.92 521.789 263.92H521.197V268H518.621V256.8ZM522.445 261.888C522.968 261.888 523.368 261.755 523.645 261.488C523.933 261.211 524.077 260.816 524.077 260.304C524.077 259.333 523.522 258.848 522.413 258.848H521.197V261.888H522.445Z"
        fill={isHighlighted ? appColors.neutral.white : appColors.color.blue1}
        opacity={isHovered ? 0.5 : 1}
        onMouseEnter={() => setHoveredBox(TIERS.MID)}
        onMouseLeave={() => setHoveredBox(null)}
      />
      <text
        x="433.5"
        y="285.5"
        fill={isHighlighted ? appColors.neutral.white : appColors.color.blue1}
        fontSize="14"
        fontWeight="light"
        fontFamily="Sarabun"
        onClick={onClick}
        style={{ userSelect: 'none', cursor: 'pointer' }}
        opacity={isHovered ? 0.5 : 1}
        onMouseEnter={() => setHoveredBox(TIERS.MID)}
        onMouseLeave={() => setHoveredBox(null)}
      >
        professional
      </text>
    </>
  );
};
